import type {AddAiItemPopOverContentState} from '@Components/add-ai-item-button/add-ai-item-button.types';
import type {MediaTypePrompt} from '@Panels/ai-image-panel/ai-image-panel.types';

export interface AddAiItemDropdownPopupContentProps {
  dropdownContentState: AddAiItemPopOverContentState;
  showAsNewFeature: AddAiItemPopUpSubPanel[];
  aiImageMediaType?: MediaTypePrompt;

  onSubPanelBack(): void;
  onDone(): void;
  onClickAiSubtitlesOption(): void;
  onClickAiImagesOption(): void;
  onClickAiVoiceOption(): void;
  onClickAiVideoOption(): void;
  onClickAiRemoveBgOption(): void;
  AiImagePanelId?: string;
  AiVoicePanelId?: string;
  AiSubtitlePanelId?: string;
  AiVideoPanelId?: string;
}

export enum AddAiItemPopUpSubPanel {
  AI_IMAGE,
  AI_SUBTITLE,
  AI_VOICE,
  AI_VIDEO,
}
